import { defineMessages } from "react-intl";

const messages = defineMessages({
  apply: {
    id: "userSelectPopoverContent.footer.buttons.apply",
    defaultMessage: "Apply",
    description: "Apply button label in the User Menu on report pages",
  },
  cancel: {
    id: "userSelectPopoverContent.footer.buttons.cancel",
    defaultMessage: "Cancel",
    description: "Cancel button label in the User Menu on report pages",
  },
  deselectAll: {
    id: "userSelectPopoverContent.footer.deselectAll",
    defaultMessage: "Deselect All",
    description: "Select All button in the User Menu on report pages",
  },
  entireOrganization: {
    id: "userSelectPopoverContent.entireOrg",
    defaultMessage: "Entire Organization",
    description: "Entire Organization item label in the User Menu on report pages",
  },
  noTeam: {
    id: "userSelectPopoverContent.noTeam",
    defaultMessage: "No Team",
    description: "No Team item label in the User Menu on report pages",
  },
  onlySelected: {
    id: "userSelectPopoverContent.onlyShowSelectedSwitch",
    defaultMessage: "Only show selected",
    description: "Only selected switch label in the User Menu on report pages",
  },
  owners: {
    id: "userSelectPopoverContent.owners",
    defaultMessage: "Owners",
    description: "Owners item label in the User Menu on report pages",
  },
  searchTeamPlaceholder: {
    id: "userSelectPopoverContent.teamSearch.placeholder",
    defaultMessage: "Search teams",
    description: "Teams search field placeholder in the User Menu on report pages",
  },
  searchUserPlaceholder: {
    id: "userSelectPopoverContent.userSearch.placeholder",
    defaultMessage: "Search users",
    description: "Users search placeholder in the User Menu on report pages",
  },
  selectAll: {
    id: "userSelectPopoverContent.footer.selectAll",
    defaultMessage: "Select All",
    description: "Select All button in the User Menu on report pages",
  },
  selectionInfo: {
    id: "userSelectPopoverContent.footer.selectionInfo",
    defaultMessage: "{count} / {total} {count, plural, one {user} other {users}} selected",
    description: "Selection info in the User Menu on report pages",
  },
});

export default messages;
